import React from 'react';
import { StyledTagGroup } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
export const TagGroup = ({ children, size, className, 'data-testid': dataTestId, margin }) => (React.createElement(StyledTagGroup, { size: size, className: className, "data-testid": dataTestId, margin: margin }, children));
//# sourceMappingURL=index.js.map